import React, { useState } from 'react'
import { message, Tooltip } from 'antd';
import { Modal, } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { onDeleteLearingGroup } from '../../../../api';
import { useDispatch, useSelector } from 'react-redux';
import { getAllGroups } from '../../../../redux/VRL/thunks';
import { CustomModal } from '../../../../components';
import { AddGroupV2 } from '../AddGroupV2';

const { confirm } = Modal;

export const GrupsBar = ({ groups, grupSelected, setgrupSelected }) => {
    const [modalEditGroup, setmodalEditGroup] = useState(false)
    const [grupEdit, setgrupEdit] = useState({})
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    const dispatch = useDispatch()

    const updateDataGroups = () => {
        dispatch(getAllGroups(proyectSelected._id))
    }

    const onDeleteGroup = async (grup) => {
        confirm({
            title: '¿Estás seguro de que deseas eliminar el grupo?',
            centered: true,
            icon: <ExclamationCircleFilled />,
            content: '',
            async onOk() {
                const result = await onDeleteLearingGroup(grup._id)
                if (result.status > 0) {
                    message.error("Error a eliminar el grupo")
                    return
                }
                if (grupSelected === grup._id) {
                    setgrupSelected("all")
                }
                message.success("Grupo eliminado")
                updateDataGroups()

            },
            onCancel() {
                console.log('Cancelar');
            },
        });

    }


    const elementsgroups = groups.map((group, index) => {
        if (group.name === "base-cemex") {
            return null;
        }
        return (
            // border-b-2 border-1990FF
            <div
                key={index} className={`${grupSelected === group._id ? "border-b-2 border-[#3366FF]" : ""}  min-w-[150px] `}>
                <div className='flex items-center  justify-between'>
                    <Tooltip title={group.name}>
                    <p
                        onClick={() => { setgrupSelected(group._id) }}
                            className={`${grupSelected === group._id ? "text-[#3366FF]" : "text-[#9A9A9A]"} p-4  font-bold text-base hover:bg-[#96a4d133] cursor-pointer`}>
                            {group.name.length >= 9 ? group.name.substring(0, 9) + "..." : group.name}
                        </p>
                    </Tooltip>
                    <Tooltip placement="rightTop" title={<>
                        <div>
                            <div className='flex justify-start items-center hover:bg-[#3366FF33]'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M14.74 9.00003L14.394 18M9.606 18L9.26 9.00003M19.228 5.79003C19.57 5.84203 19.91 5.89703 20.25 5.95603M19.228 5.79003L18.16 19.673C18.1164 20.2383 17.8611 20.7662 17.445 21.1513C17.029 21.5364 16.4829 21.7502 15.916 21.75H8.084C7.5171 21.7502 6.97102 21.5364 6.55498 21.1513C6.13894 20.7662 5.88359 20.2383 5.84 19.673L4.772 5.79003M19.228 5.79003C18.0739 5.61555 16.9138 5.48313 15.75 5.39303M4.772 5.79003C4.43 5.84103 4.09 5.89603 3.75 5.95503M4.772 5.79003C5.92613 5.61555 7.08623 5.48313 8.25 5.39303M15.75 5.39303V4.47703C15.75 3.29703 14.84 2.31303 13.66 2.27603C12.5536 2.24067 11.4464 2.24067 10.34 2.27603C9.16 2.31303 8.25 3.29803 8.25 4.47703V5.39303M15.75 5.39303C13.2537 5.20011 10.7463 5.20011 8.25 5.39303" stroke="#3366FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <p onClick={() => { onDeleteGroup(group) }} className="text-3366FF cursor-pointer w-[144px] pl-2 py-3">
                                    Eliminar
                                </p>
                            </div>
                            <div className='flex justify-start items-center hover:bg-[#3366FF33] pl-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M14.862 3.487L16.549 1.799C16.9007 1.44733 17.3777 1.24976 17.875 1.24976C18.3723 1.24976 18.8493 1.44733 19.201 1.799C19.5527 2.15068 19.7502 2.62766 19.7502 3.125C19.7502 3.62235 19.5527 4.09933 19.201 4.451L8.582 15.07C8.05332 15.5984 7.40137 15.9867 6.685 16.2L4 17L4.8 14.315C5.01328 13.5986 5.40163 12.9467 5.93 12.418L14.862 3.487ZM14.862 3.487L17.5 6.125M16 13V17.75C16 18.3467 15.7629 18.919 15.341 19.341C14.919 19.763 14.3467 20 13.75 20H3.25C2.65326 20 2.08097 19.763 1.65901 19.341C1.23705 18.919 1 18.3467 1 17.75V7.25C1 6.65327 1.23705 6.08097 1.65901 5.65901C2.08097 5.23706 2.65326 5 3.25 5H8" stroke="#3366FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <p onClick={() => {
                                    setgrupEdit(group)
                                    setmodalEditGroup(true)
                                }} className="text-3366FF cursor-pointer w-[144px] pl-2 py-3">
                                    Editar
                                </p>
                            </div>

                        </div>
                    </>} color="#FFFFFF" overlayInnerStyle={{ color: "#3366FF" }}>
                        <div className=' cursor-pointer hover:bg-[#96a4d133] '>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 6.75C11.8011 6.75 11.6103 6.67098 11.4697 6.53033C11.329 6.38968 11.25 6.19891 11.25 6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6C12.75 6.19891 12.671 6.38968 12.5303 6.53033C12.3897 6.67098 12.1989 6.75 12 6.75ZM12 12.75C11.8011 12.75 11.6103 12.671 11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25C12.1989 11.25 12.3897 11.329 12.5303 11.4697C12.671 11.6103 12.75 11.8011 12.75 12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75ZM12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18C11.25 17.8011 11.329 17.6103 11.4697 17.4697C11.6103 17.329 11.8011 17.25 12 17.25C12.1989 17.25 12.3897 17.329 12.5303 17.4697C12.671 17.6103 12.75 17.8011 12.75 18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75Z" stroke="#9A9A9A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </Tooltip>

                </div>
            </div>
        );
    });
    return (
        <>
        <div className='flex justify-start items-center overflow-x-auto w-full'>
            <div
                onClick={() => { setgrupSelected("all") }}
                className={`${grupSelected === "all" ? "border-b-2 border-[#3366FF]" : ""} min-w-[168px] `}>
                <p className={`${grupSelected === "all" ? "text-[#3366FF]" : "text-[#9A9A9A]"} p-4 font-bold text-base hover:bg-[#96a4d133] cursor-pointer`}>Todos los grupos</p>
            </div>
            {
                elementsgroups
            }
        </div>
            <CustomModal
                key={"AddGroup"}
                isVisible={modalEditGroup}
                close={() => { setmodalEditGroup(false) }}
                title={`Editar grupo`}
                width={"430px"}
                height={"510px"}
            >
                <AddGroupV2 editing={true} grupToEdit={grupEdit} close={() => { setmodalEditGroup(false) }} />
            </CustomModal>
        </>

    )
}